import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal, CommonServices } from 'src/modules/shared';
import {
  AwardLotModal,
  SelectionMethodModal,
} from 'src/modules/features/admin/modals';
import { Location } from '@angular/common';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactProvider, UserService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-account-payment',
  templateUrl: './account-payment.component.html',
  styleUrls: ['./account-payment.component.scss'],
})
export class Step3Component implements OnInit, OnDestroy {
  registrationSidebar;
  isCorrect: string = 'true';
  success: any;
  error: any;
  errorMsg: any;
  successMsg: any;
  pending: boolean;
  userObject: any;
  ownershipType: Array<any> = [];
  companyType: Array<any> = [];
  ownership: any;
  company: any;
  validation: boolean;
  verifyDetail: boolean;
  provideDetail: boolean;
  formSubmitAttempt: boolean;
  noDetail: boolean;
  noRecord: boolean;
  tries: number = 3;
  detailForm: FormGroup;
  companyTypes: Array<any> = [];
  validateError = {
    NO_MATCH: false,
    TIN_NUMBER_NOT_FOUND: false,
    LICENCE_RECORD_MATCHED: false,
    CAC_AND_FIRS_RECORD_MATCHED: false,
    CAC_AND_LICENCE_RECORD_MATCHED: false,
    CAC_AND_USER_COMPANY_NAME_MATCHED: false,
  };
  match = [
    'LICENCE_RECORD_MATCHED',
    'CAC_AND_FIRS_RECORD_MATCHED',
    'CAC_AND_LICENCE_RECORD_MATCHED',
    'CAC_AND_USER_COMPANY_NAME_MATCHED',
    'CAC_RECORD_MATCHED',
  ];
  validatedRecord;
  companyName: string;
  msgForm: FormGroup;
  isSendMessage: boolean;
  currentTitle = 'Create an Account';
  mpending: boolean;
  source;
  token: string | null = null;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private userSvc: UserService,
    private fb: FormBuilder,
    private router: Router,
    private _contactsvc: ContactProvider,
    private commonSvc: CommonServices
  ) {
    this.mpending = true;
    this.commonSvc
      .getTemplate({ messageTemplateId: 'CONTACT_SIDE_BAR' })
      .subscribe((res: any) => {
        this.registrationSidebar = res.mailTemplate;
        this.mpending = false;
      });
    this.detailForm = this.fb.group({
      rc_number: [''],
      tin_number: [''],
      company_type: [''],
      nccId: [''],
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.source = params['source'];
      this.token = params['token'];
    });

    this.msgForm = this.fb.group({
      email: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
    this.userObject = JSON.parse(window.localStorage.getItem('userObject'));
    let option = JSON.parse(window.localStorage.getItem('options'));
    if (option) {
      this.ownershipType = option['ownershipType'];
      this.companyType = option['companyType'];
    }
    this.ownership = this.ownershipType.filter(
      (res) => res.optionId === this.userObject.ownership_type
    )[0];
    this.company = this.companyType.filter(
      (res) => res.optionId === this.userObject.company_type
    )[0];

    this.submit();
    if (window.localStorage.getItem('tries')) {
      this.tries = JSON.parse(window.localStorage.getItem('tries'));
    }
  }
  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  myHandleError() {}
  // inline editing
  saveEditable(value, name) {
    this.detailForm.value[name] = value;
  }
  provideDetailAgain() {
    this.noRecord = false;
    // this.verifyDetail = true;
    this.provideDetail = true;
  }

  submitName() {
    if (this.isCorrect !== 'true') {
      this.submitCompanyName();
    } else {
      this.proceed();
    }
  }

  submitCompanyName() {
    if (this.tries == 0) {
      return;
    }
    this.pending = true;
    this.userSvc
      .validateSignUp({
        body: {
          // rcNumber: this.userObject['rc_number'],
          // nccId: '221540919130'
          // tinNumber: this.userObject['tin_number'],
          // userCompanyName: this.userObject['companyName']
          rcNumber: this.userObject['rc_number'],
          nccId: this.userObject['nccId'],
          tinNumber: this.userObject['tin_number'],
          userCompanyName: this.companyName,
          actualCompanyType: this.userObject['company_type'],
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          if (this.match.indexOf(res['status']) > -1) {
            this.validatedRecord = res;
            this.verifyDetail = true;
            this.provideDetail = false;
            this.noRecord = false;
          } else {
            this.verifyDetail = false;
            this.noRecord = true;
          }
          window.localStorage.setItem('tries', JSON.stringify(this.tries - 1));
          this.tries--;
          this.isCorrect = 'true';
          console.log(this.tries);
        },
        (error) => {
          this.pending = false;
          // his.noRecord = true;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  showFormMsg() {
    this.router.navigate(['/home-page/contact']);
  }

  removeFormMsg() {
    this.currentTitle = 'Create an Account';
    this.isSendMessage = false;
    this.provideDetail = true;
    this.noRecord = true;
  }

  sendMsg() {
    this.pending = true;
    this._contactsvc.sendContactMessage(this.msgForm.value).subscribe(
      (d) => {
        this.pending = false;
        this.msgForm.reset;
        this.successMsg = 'Succesful!';
      },
      (error) => {
        this.pending = false;
        this.errorMsg = error.message ? error.message : error;
      }
    );
  }

  submitDetail() {
    if (this.tries == 0) {
      return;
    }
    this.pending = true;
    this.userSvc
      .validateSignUp({
        body: {
          rcNumber: this.detailForm.value.rc_number,
          nccId: this.detailForm.value.nccId,
          tinNumber: this.detailForm.value.tin_number,
          actualCompanyType: this.userObject['company_type'],
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          if (this.match.indexOf(res['status']) > -1) {
            this.validatedRecord = res;
            this.verifyDetail = true;
            this.provideDetail = false;
            this.noRecord = false;
          } else {
            this.verifyDetail = false;
            this.noRecord = true;
          }
          window.localStorage.setItem('tries', JSON.stringify(this.tries - 1));
          this.tries--;
        },
        (error) => {
          this.pending = false;
          // his.noRecord = true;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  proceed() {
    window.localStorage.setItem(
      'userObject',
      JSON.stringify({ ...this.userObject, ...this.validatedRecord })
    );
    console.log(this.source, 'source');
    this.source === 'procurement'
      ? this.router.navigate(['/home-page/sign-up/step4'], {
          queryParams: { source: 'procurement', token: this.token },
        })
      : this.router.navigate(['/home-page/sign-up/step4']);
  }

  errorMessg;
  tinErrorMessage;
  submit() {
    this.pending = true;
    console.log(this.userObject, 'userObject');
    const body = {
      rcNumber: this.userObject['rc_number'],
      nccId: this.userObject['nccId'],
      tinNumber: this.userObject['tin_number'],
      actualCompanyType: this.userObject['company_type'],
    };
    if (this.token) {
      body['invitationToken'] = this.token;
      body['invitationFrom'] = 'procurement';
    }
    this.userSvc.validateSignUp({ body }).subscribe(
      (res) => {
        this.pending = false;
        if (this.match.indexOf(res['status']) > -1) {
          this.validatedRecord = res;

          this.verifyDetail = true;
          this.noRecord = false;
        } else {
          this.noRecord = true;
        }
      },
      (error) => {
        this.pending = false;
        // this.verifyDetail = true;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
        if (
          this.error['status'] == 412 ||
          this.error['status'] == 403 ||
          this.error['errorCode'] == 200412
        ) {
          this.errorMessg = true;
        }
        if (this.error['status'] == 414) {
          this.tinErrorMessage = true;
        }
      }
    );
  }
  validateRules() {
    // const app = {
    // 	CAC_AND_LICENCE_RECORD_MATCHED: 'false',
    // 	CAC_AND_LICENCE_RECORD_MATCHED: 'false'
    // };
    // let value = 'FUW/PG2022/0050';
    // switch (value) {
    // 	case 'val':
    // 		console.log(value);
    // 		break;
    // }
  }
  enterNumber() {
    this.modalService
      .open(
        new EmailModal(
          'Enter Number',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  goBack() {
    this.location.back();
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {
    window.localStorage.removeItem('tries');
  }
}
